// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR, DS_HEIGHT } from '@calm/evexia-design-tokens';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import { Checkmark, CheckmarkProps } from '@rhg/libs/material/icons';
import { sxAppend } from '@rhg/libs/material/sx';

const styleBox = {
    height: DS_HEIGHT.BUTTON_SMALL,
    width: DS_HEIGHT.BUTTON_SMALL,
    borderRadius: '50%',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? DS_COLOR.LIGHT_INFO_LIGHT
            : DS_COLOR.DARK_INFO_DARK,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& path': {
        fill: (theme: Theme) =>
            theme.palette.mode === 'light'
                ? DS_COLOR.LIGHT_INFO_MAIN
                : DS_COLOR.DARK_INFO_MAIN,
    },
};

interface CompletedStatusProps {
    sx?: SxProps<Theme>;
    size: CheckmarkProps['size'];
}
export function CompletedStatus({ sx, size }: CompletedStatusProps) {
    return (
        <Box sx={sxAppend(styleBox, sx)}>
            <Checkmark size={size} />
        </Box>
    );
}
